import moment from 'moment'

import { passwordMatches } from '../../imports/validation'

export const required = value => (value ? undefined : 'global.label.requiredField')

export const dateRequired = value =>
  value && value.year && value.month && value.day ? undefined : 'global.label.requiredField'

export const maxLength = max => value =>
  value && value.length > max ? { string: 'error.global.maxCharacter', values: { max } } : undefined

export const minLength = min => value =>
  value && value.length < min ? { string: 'error.global.minCharacter', values: { min } } : undefined

export const number = value =>
  value && isNaN(Number(value)) ? 'error.global.mustBeNumber' : undefined

export const minValue = min => value => value && value < min ? `Must be at least ${min}` : undefined

export const emailValidator = value =>
  value &&
  !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(
    value
  )
    ? 'error.email.isInvalid'
    : undefined

export const alphaNumeric = value =>
  value && /[^a-zA-Z0-9 ]/i.test(value) ? 'error.global.alphanumeric' : undefined

export const phoneNumber = value =>
  value && !/^(0|[1-9][0-9]{9})$/i.test(value) ? 'error.registration.invalidPhone' : undefined

export const password = value =>
  passwordMatches(value) ? 'error.password.characterRequired' : undefined

// Only for Register
export const validAge = value => {
  if (value && value.year && value.month && value.day) {
    const currentdate = moment()
    const birthdate = moment(`${value.year}/${value.month}/${value.day}`, 'YYYY-MM-DD')
    const age = currentdate.diff(birthdate, 'years', true)
    if (age < 17) {
      return 'page.registrationPage.global.registrationAgeDisclaimer'
    }
  }
  return undefined
}
